import { Action, createStore, Store } from 'redux'

import reducer from './rootReducer'
import { AppState } from 'src/interfaces/app'

export function initStore(): Store<AppState, Action> {
  // @ts-ignore
  return createStore(reducer)
}
